export enum MarketTypeEnum {
  BOVESPA = 'XBSP',
  BMF = 'XBMF'
}
